import type { IconData } from '@stacksjs/iconify-core'

export const treeAltF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 14.858H1.674a1 1 0 0 1-.88-1.474l1.9-3.529a1 1 0 0 1-.785-1.512l4.234-7.056a1 1 0 0 1 1.714 0l4.234 7.056a1 1 0 0 1-.785 1.512l1.9 3.529a1 1 0 0 1-.88 1.474H8v6H6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default treeAltF
